import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  postRelatorioBeneficiarioRequest: ['params'],
  postRelatorioBeneficiarioResponse: ['success', 'data', 'error'],

  postRelatorioNestleRequest: ['sendEmail'],
  postRelatorioNestleResponse: ['success', 'data', 'error'],

  getUltimoRelatorioNestleRequest: [],
  getUltimoRelatorioNestleResponse: ['success', 'data', 'error'],

  downloadRelatorioNestleRequest: ['id'],
});

const INICIAL_STATE = {
  postRelatorioBeneficiarioRequest: {
    success: false,
    error: null,
    loading: false,
    data: {
      taskId: null,
      isSuccess: false,
    },
  },
  postRelatorioNestleRequest: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getUltimoRelatorioNestle: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
};

// #region [POST] relatorios/relatorio-beneficiario-nestle
const postRelatorioBeneficiarioRequest = (state = INICIAL_STATE) => ({
  ...state,
  postRelatorioBeneficiarioRequest: {
    success: false,
    error: null,
    loading: true,
    data: {},
  },
});

const postRelatorioBeneficiarioResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  postRelatorioBeneficiarioRequest: {
    success: action.success,
    error: action.error,
    loading: false,
    data: action.data,
  },
});
// #endregion
// #region [POST] relatorios/relatorio-beneficiario-nestle
const postRelatorioNestleRequest = (state = INICIAL_STATE) => ({
  ...state,
  postRelatorioNestleRequest: {
    success: false,
    error: null,
    loading: true,
    data: {},
  },
});

const postRelatorioNestleResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  postRelatorioNestleRequest: {
    success: action.success,
    error: action.error,
    loading: false,
    data: action.data,
  },
});
// #endregion

// #region [GET] /api/v1/relatorios/ultimo-relatorio-beneficiario-nestle
const getUltimoRelatorioNestleRequest = (state = INICIAL_STATE) => ({
  ...state,
  getUltimoRelatorioNestle: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
});

const getUltimoRelatorioNestleResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  getUltimoRelatorioNestle: {
    success: action.success,
    error: action.error,
    loading: false,
    data: action.data,
  },
});
// #endregion

// #region [GET] /api/v1/relatorios/relatorio-beneficiario-nestle/{id}
const downloadRelatorioNestleRequest = (state = INICIAL_STATE) => ({
  ...state,
});
// #endregion

export default createReducer(INICIAL_STATE, {
  [Types.POST_RELATORIO_BENEFICIARIO_REQUEST]: postRelatorioBeneficiarioRequest,
  [Types.POST_RELATORIO_BENEFICIARIO_RESPONSE]:
    postRelatorioBeneficiarioResponse,

  [Types.POST_RELATORIO_NESTLE_REQUEST]: postRelatorioNestleRequest,
  [Types.POST_RELATORIO_NESTLE_RESPONSE]: postRelatorioNestleResponse,

  [Types.GET_ULTIMO_RELATORIO_NESTLE_REQUEST]: getUltimoRelatorioNestleRequest,
  [Types.GET_ULTIMO_RELATORIO_NESTLE_RESPONSE]:
    getUltimoRelatorioNestleResponse,

  [Types.DOWNLOAD_RELATORIO_NESTLE_REQUEST]: downloadRelatorioNestleRequest,
});
